import React from 'react';
import {Redirect} from 'react-router';
import {Editor} from 'react-draft-wysiwyg';
import {EditorState, convertToRaw, ContentState, convertFromHTML} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import withStyles from "@material-ui/core/styles/withStyles";
import htmlToDraft from 'html-to-draftjs';

//import AlertBox from 'components/AlertBox/alertbox.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import ImageUpload from "components/CustomUpload/ImageUploadForUpdate.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import CardFooter from "components/Card/CardFooter.jsx";
import TagInputAutoSuggest from "components/Forms/ClinicForm/TagInputAutoSuggest.jsx";
import ClinicTimings from "components/Forms/ClinicForm/addTimings.jsx";
import ClinicTimingsEdit from "components/Forms/ClinicForm/updateTimings.jsx";

import 'react-tagsinput/react-tagsinput.css';
import TagsInput from 'react-tagsinput';
import {NavLink} from 'react-router-dom';


// style for this view
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import Icon from '@material-ui/core/Icon';
import {
    verifyEmail,
    verifyName,
    verifyAlphaNum, verifyUrl,
    verifyNumber, verifyPincode,
    verifyPhoneNumber, dashboardRouter
} from '../../../util/globalHelper'
import api from "../../../api/Api";
import Loader from "../../Loader";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

class ValidationForms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            doctorID: "",
            data: null,
            specialities: [],
            timings: [{day: "mon", open_time: "", close_time: ""},
                {day: "tues", open_time: "", close_time: ""},
                {day: "wednes", open_time: "", close_time: ""},
                {day: "thurs", open_time: "", close_time: ""},
                {day: "fri", open_time: "", close_time: ""},
                {day: "satur", open_time: "", close_time: ""},
                {day: "sun", open_time: "", close_time: ""}
            ],
            // validation
            number: "",
            numberState: "",
            name: "",
            nameState: "success",
            last_name: "",
            last_nameState: "success",
            phoneNumberState: "success",
            phoneNumber: "",
            mciNumber: "",
            mciNumberState: "",
            alert: null,
            open: true,
            experience: "",
            experienceState: "",
            qualification: "",
            qualificationState: "",
            signature: "",
            signatureState: "",
            imageurl: "",
            registerEmail: "",
            registerEmailState: "success",
            gender: "",
            genderState: "",
            services: [],
            online: "false",
            redirect: false,
            simpleSelect: "",
            role: "doctor",
            roleService: "doctor_clinic",
            selectedValue: null,
            timingsadded: false,
            clinic_id: "",
            clinic_name: "",
            loading: true,
            clinicUpdate: false,
            clinicID: "",
            contentState: {}


        };
        this.handleRadioChange = this.handleRadioChange.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
        this.typeClick = this.typeClick.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.handleChangeGender = this.handleChangeGender.bind(this);
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.CreateAlert = this.CreateAlert.bind(this);
        this.CreateAlertForEdit = this.CreateAlertForEdit.bind(this);
    }


    handleChangeSpecialities(specialities) {
        this.setState({
            specialities: specialities.filter((v, i, a) => {
                return a.indexOf(v) === i
            })
        })
    }

    handleImageUrl(url) {
        this.setState({imageurl: url});
    }

    handleChangeServices(services) {
        this.setState({
            services: services.filter((v, i, a) => {
                return a.indexOf(v) === i
            })
        });
    }

    handleChangeGender(event) {
        this.setState({
            gender: event.target.value
        });
    }

    handleTimings(timings) {
        this.setState({timings});
        this.setState({timingsadded: true});
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "alphanum":
                if (verifyAlphaNum(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "novalidation":
                if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else if (event.target.value === "" && inputType === "required") {
                    this.setState({[stateName + "State"]: "error"});
                } else {
                    this.setState({[stateName + "State"]: "success"});
                }
                break;
            default:
                break;
        }
    }

    onEditorStateChange(description) {
        this.setState({
            description,
        });
    };

    CallReadApi = (id) => {
        var timingsAdd = 0;

        api.getDoctorById(id).then(json => {
            this.setState({
                data: json.data.data,
                doctor_id: json.data.data.doctor_id,
                name: json.data.data.user_details.name,
                registerEmail: json.data.data.user_details.email,
                specialities: json.data.data.doctor_speciality.map(function (obj) {
                    return obj.speciality
                }),
                description: EditorState.createWithContent(ContentState.createFromBlockArray((htmlToDraft(json.data.data.description)).contentBlocks)),
                // description: draftToHtml(convertToRaw(this.state.description.getCurrentContent())),
                phoneNumber: json.data.data.user_details.contact,
                gender: json.data.data.user_details.gender,
                qualification: json.data.data.doctor_qualification,
                experience: json.data.data.doctor_experience,
                online: JSON.stringify(this.state.online_consultations_provided),
                imageurl: json.data.data.user_details.profile_image,
                mciNumber: json.data.data.doctor_MCI_Number,
                signature: json.data.data.signature ? json.data.data.signature : ""
            });
            var row, i;
            for (row in json.data.data.doctor_clinics) {
                if (json.data.data.doctor_clinics[row].clinic_id && json.data.data.doctor_clinics[row].clinic_id._id === this.state.clinicID) {
                    this.setState({timings: json.data.data.doctor_clinics[row].timings});
                    for (i in json.data.data.doctor_clinics[row].timings) {
                        if (json.data.data.doctor_clinics[row].timings[i].open_time !== "" && json.data.data.doctor_clinics[row].timings[i].close_time !== "") {
                            timingsAdd = 1;
                        }
                    }
                    if (timingsAdd === "1") {
                        this.setState({timingsadded: true});
                    }
                    this.setState({
                        services: json.data.data.doctor_clinics[row].services.map(function (obj) {
                            return obj.service
                        }),
                        signature: json.data.data.doctor_clinics[row].signature

                    })
                }
            }

            this.setState({loading: false});
        });
    }

    componentDidMount() {
        if (this.props.id.match.params.clinicID)
            this.setState({
                clinicID: this.props.id.match.params.clinicID,
                clinicUpdate: true
            })
        this.CallReadApi(this.props.id.match.params.doctorID);

    }


    hideAlert() {
        this.setState({
            alert: null
        });
    }

    handleRadioChange(event) {
        this.setState({selectedValue: event.target.value});

    }

    CalUpdateDocApi(id, data) {
        //api.createDoctor( data).then(json => {
        api.updateDoctorById(id, data).then(json => {
            if (json.data.isError) {
                var msgcolor = {message: json.data.message.message, color: "danger"};
                this.props.id.generateNotification(msgcolor);
            } else {
                this.setState({redirect: true});
                if (this.props.subscription === "done") {
                    var msgcolor = {message: "Doctor Updated Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    this.props.id.history.push(dashboardRouter(`/doctor/oneDoctor/${id}`))
                } else {
                    var msgcolor = {message: "Doctor Added Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    this.props.id.history.push(dashboardRouter(`/doctor/oneDoctor/${id}`))
                }
            }
        }).catch(error => {
            var msgcolor = {message: "Server Error!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        })
    }

    CreateAlert() {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title"><ClinicTimings
                        generateNotification={this.props.id.generateNotification.bind(this)}
                        handleTimings={this.handleTimings.bind(this)}
                        hideAlert={this.hideAlert.bind(this)}/></DialogTitle>
                </Dialog>
            )
        });
    }

    CreateAlertForEdit() {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title"><ClinicTimingsEdit
                        generateNotification={this.props.id.generateNotification.bind(this)}
                        handleTimings={this.handleTimings.bind(this)} hideAlert={this.hideAlert.bind(this)}
                        timings={this.state.timings}/></DialogTitle>
                </Dialog>
            )
        });
    }

    handleChangeSpecialities(specialities) {
        this.setState({
            specialities: specialities.filter((v, i, a) => {
                return a.indexOf(v) === i
            })
        });
    }

    typeClick() {
        if (this.state.name === "") {
            this.setState({nameState: "error"});
        }
        // if (this.state.last_name === "") {
        //     this.setState({last_nameState: "error"});
        // }
        if (this.state.phoneNumberState === "") {
            this.setState({phoneNumberState: "error"});
        }
        if (this.state.nameState === "success" &&
            // this.state.last_nameState === "success" &&
            this.state.phoneNumberState === "success"
            && this.state.mciNumberState !== "error" && this.state.registerEmailState !== "error" && this.state.experienceState !== "error" && this.state.qualificationState !== "error"
        ) {
            var newClinicsobject = {
                "timings": this.state.timings,
                "services": this.state.services,
                "clinic_id": this.state.clinicID,
                "signature": this.state.signature
            }
            var oldObject = this.state.data.doctor_clinics
            if (this.state.clinicUpdate) {
                var i = oldObject.findIndex(o => o.clinic_id._id === newClinicsobject.clinic_id);
                if (oldObject[i]) {
                    oldObject[i] = newClinicsobject
                } else {
                    oldObject.push(newClinicsobject)
                }
            }

            var data = this.state.clinicUpdate ? {
                clinics: oldObject,
                clinic_id: this.state.clinicID
            } : {
                speciality: this.state.specialities,
                name: this.state.name,
                contact: this.state.phoneNumber,
                mci_number: this.state.mciNumber,
                experience: this.state.experience,
                qualification: this.state.qualification,
                profile_image: this.state.imageurl,
                email: this.state.registerEmail,
                gender: this.state.gender,
                online_consultations_provided: JSON.parse(this.state.online),
                display_name: "Dr. " + this.state.name,
                description: draftToHtml(convertToRaw(this.state.description.getCurrentContent()))
                // clinic_id: this.state.clinic_id
            }
            this.CalUpdateDocApi(this.props.id.match.params.doctorID, data);
            // this.CallTagMasterServices();
        } else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }

    }

    CallTagMasterServices() {
        var data = {
            service_text: this.state.services,
            service_role: this.state.role
        }
        api.createService(data).then(json => {
            if (json.data.isError) {
                var msgcolor = {message: json.data.message.message, color: "danger"};
                this.props.id.generateNotification(msgcolor);
            } else {
            }
        });
    }


    render() {
        const {classes} = this.props;
        if (this.state.name !== "")
            return (
                <div>
                    {this.state.alert}
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <form>
                                {this.state.clinicUpdate ? null :
                                    <GridContainer className={classes.justifyContentCenter}>
                                        <GridItem xs={12} sm={7} md={5}>
                                            <CustomInput
                                                labelText="Name"
                                                id="name"
                                                success={this.state.nameState === "success"}
                                                error={this.state.nameState === "error"}
                                                formControlProps={{
                                                    fullWidth: true,
                                                    required: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "name", "name", "required"),
                                                    value: this.state.name
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={7} md={5}>
                                            <CustomInput
                                                success={this.state.registerEmailState === "success"}
                                                error={this.state.registerEmailState === "error"}
                                                labelText="Email "
                                                id="registeremail"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "registerEmail", "email", "optional"),
                                                    value: this.state.registerEmail,
                                                    type: "email",

                                                }}
                                            />
                                        </GridItem>
                                    </GridContainer>}
                                {this.state.clinicUpdate ? null :
                                    <GridContainer className={classes.justifyContentCenter}>

                                        <GridItem xs={12} sm={7} md={5}>
                                            <CustomInput
                                                labelText="Phone Number"
                                                success={this.state.phoneNumberState === "success"}
                                                error={this.state.phoneNumberState === "error"}
                                                id="phonenumber"
                                                formControlProps={{
                                                    fullWidth: true,
                                                    required: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "phoneNumber", "phonenumber", "required"),
                                                    value: this.state.phoneNumber,

                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={7} md={5}>
                                            <CustomInput
                                                labelText="MCI Number"
                                                success={this.state.mciNumberState === "success"}
                                                error={this.state.mciNumberState === "error"}
                                                id="mci"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "mciNumber", "alphanum", "optional"),
                                                    value: this.state.mciNumber,

                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={7} md={5}>
                                            <CustomInput
                                                labelText="Qualification"
                                                success={this.state.qualificationState === "success"}
                                                error={this.state.qualificationState === "error"}
                                                id="mci"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "qualification", "novalidation", "optional"),
                                                    value: this.state.qualification,

                                                }}
                                            />
                                        </GridItem>

                                        <GridItem xs={12} sm={7} md={5}>
                                            <CustomInput
                                                labelText="Experience"
                                                success={this.state.experienceState === "success"}
                                                error={this.state.experienceState === "error"}
                                                id="experience"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "experience", "novalidation", "optional"),
                                                    value: this.state.experience,

                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={7} md={5}>
                                            <div style={{minHeight: '100px'}}>
                                                <legend>Description</legend>
                                                <Editor
                                                    wrapperClassName="wrapper-class"
                                                    editorClassName="editor-class"
                                                    toolbarClassName="toolbar-class"
                                                    defaultEditorState={this.state.description}
                                                    onEditorStateChange={this.onEditorStateChange}
                                                />
                                                <br/>
                                            </div>
                                        </GridItem>
                                        <GridItem xs={12} sm={7} md={5}>
                                            <legend>Specialities</legend>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <TagInputAutoSuggest
                                                    handleChangeSpecialities={this.handleChangeSpecialities.bind(this)}
                                                    specialities={this.state.specialities} role={this.state.role}
                                                    tagname={"speciality"}
                                                    value={this.state.specialities}
                                                    inputProps={{placeholder: ""}}/>
                                            </GridItem>
                                        </GridItem>

                                        <GridItem xs={12} sm={7} md={5}>
                                            <legend>Gender</legend>
                                            <RadioGroup aria-label="position" name="position"
                                                        value={(this.state.gender === "male" || this.state.gender === "Male" || this.state.gender === "M") ? "M" : "F"}
                                                        onChange={this.handleChangeGender} row>
                                                <FormControlLabel
                                                    value={"M"}
                                                    control={<Radio color="primary"/>}
                                                    label="Male"
                                                    labelPlacement="end"
                                                />
                                                <FormControlLabel
                                                    value={"F"}
                                                    control={<Radio color="primary"/>}
                                                    label="Female"
                                                    labelPlacement="end"
                                                />
                                            </RadioGroup>
                                        </GridItem>
                                        <GridItem xs={12} sm={7} md={5}>
                                            <FormControl
                                                fullWidth
                                                className={classes.selectFormControl}>
                                                <InputLabel
                                                    htmlFor="simple-select"
                                                    className={classes.selectLabel}>
                                                    Online Consultation
                                                </InputLabel>
                                                <Select
                                                    MenuProps={{
                                                        className: classes.selectMenu
                                                    }}
                                                    classes={{
                                                        select: classes.select
                                                    }}
                                                    onChange={this.onChangeSelect}
                                                    value={this.state.online}
                                                    inputProps={{
                                                        name: "online",
                                                        id: "online"
                                                    }}
                                                >
                                                    <MenuItem
                                                        disabled
                                                        classes={{
                                                            root: classes.selectMenuItem
                                                        }}>
                                                        Select Consultation Type
                                                    </MenuItem>
                                                    <MenuItem
                                                        classes={{root: classes.selectMenuItem}}
                                                        style={{height: "1.8em"}}
                                                        value={"true"}>Online</MenuItem>
                                                    <MenuItem
                                                        classes={{root: classes.selectMenuItem}}
                                                        style={{height: "1.8em"}}
                                                        value={"false"}>Offline</MenuItem>
                                                </Select>
                                            </FormControl>
                                            <br/>
                                        </GridItem>

                                        <GridItem xs={12} sm={7} md={5}>

                                            <ImageUpload
                                                addButtonProps={{
                                                    color: "warning",
                                                    round: false
                                                }}
                                                changeButtonProps={{
                                                    color: "warning",
                                                    round: false
                                                }}
                                                removeButtonProps={{
                                                    color: "grey",
                                                    round: false
                                                }}
                                                handleImageUrl={this.handleImageUrl.bind(this)}
                                                imageurl={this.state.imageurl}
                                                role="Doctor"
                                            />
                                            {/*<GridItem xs={12} md={12} sm={12}>*/}
                                            {/*{this.state.imageurl !== "" ?*/}
                                            {/*(            <div className="fileinput text-center">*/}
                                            {/*<div className="thumbnail">*/}
                                            {/*<img src={this.state.imageurl} onError={(e) => {*/}
                                            {/*e.onerror = null;*/}
                                            {/*e.target.src = require('assets/img/placeholder.jpg')*/}
                                            {/*}}/>*/}
                                            {/*</div>*/}
                                            {/*</div>) : <ImageUpload*/}
                                            {/*addButtonProps={{*/}
                                            {/*color: "rose",*/}
                                            {/*round: true*/}
                                            {/*}}*/}
                                            {/*changeButtonProps={{*/}
                                            {/*color: "rose",*/}
                                            {/*round: true*/}
                                            {/*}}*/}
                                            {/*removeButtonProps={{*/}
                                            {/*color: "danger",*/}
                                            {/*round: true*/}
                                            {/*}}*/}
                                            {/*handleImageUrl={this.handleImageUrl.bind(this)}*/}
                                            {/*role="Doctor"*/}
                                            {/*/>}*/}
                                            {/*</GridItem>*/}
                                        </GridItem></GridContainer>}
                                {this.state.clinicUpdate ? <GridContainer className={classes.justifyContentCenter}>
                                    <GridItem xs={12}>
                                        <br/>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={5}>
                                        <GridContainer>
                                            <GridItem xs={12} sm={4} md={4}>
                                                <legend>Timings</legend>
                                            </GridItem>
                                            {this.state.timingsadded ? (
                                                <GridItem xs={12} sm={12} md={8}>
                                                    <GridContainer>
                                                        <GridItem xs={12} sm={4} md={6}>
                                                            <Button color="danger"><Icon style={{
                                                                fontSize: 15,
                                                                marginRight: "15%"
                                                            }}>done</Icon>Added</Button>
                                                        </GridItem>
                                                        <GridItem xs={12} sm={4} md={6}>
                                                            <Button color="warning"
                                                                    onClick={this.CreateAlertForEdit}>Edit</Button>
                                                        </GridItem></GridContainer> </GridItem>) : (
                                                <GridItem xs={12} sm={4} md={3}>
                                                    <Button color="warning"
                                                            onClick={this.CreateAlertForEdit}>Edit</Button>
                                                </GridItem>)}

                                        </GridContainer>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={5}>
                                        <legend>Services</legend>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <TagInputAutoSuggest
                                                handleChangeServices={this.handleChangeServices.bind(this)}
                                                services={this.state.services} role={this.state.roleService}
                                                tagname="service"/>
                                        </GridItem>
                                    </GridItem>

                                    <GridContainer>
                                        <GridItem xs={12} sm={2} md={2}></GridItem>

                                        <GridItem xs={12} sm={6} md={6}>
                                            <CustomInput
                                                labelText="Signature"
                                                success={this.state.signatureState === "success"}
                                                error={this.state.signatureState === "error"}
                                                id="experience"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "signature", "novalidation", "optional"),
                                                    value: this.state.signature,
                                                }}
                                            /></GridItem>
                                    </GridContainer>
                                </GridContainer> : null}
                            </form>
                            <CardFooter className={classes.justifyContentCenter}>
                                <GridContainer className={classes.justifyContentCenter}>
                                    <GridItem xs={12} sm={2}>
                                        <Button block color="warning" onClick={this.typeClick}>
                                            Update
                                        </Button>
                                    </GridItem>
                                    <GridItem xs={12} sm={2}>
                                        <NavLink to={dashboardRouter(`/doctor/oneDoctor/${this.state.doctor_id}`)}>
                                            <Button block size="md">Cancel
                                            </Button>
                                        </NavLink>
                                        <br/>
                                    </GridItem>
                                </GridContainer>
                            </CardFooter>
                        </GridItem>
                    </GridContainer>

                </div>
            )
        else
            return (
                <div>
                    <br/>
                    <Loader/>
                    <br/><br/>
                </div>)
    }
    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

}

export default withStyles(validationFormsStyle, extendedFormsStyle)(ValidationForms);



// WEBPACK FOOTER //
// ./src/components/Forms/DoctorForm/AddExistingForm.jsx